import * as SidebarActionTypes from '../../../constants/sidebar/ActionTypes';
import { PanelTypes, ModuleTypes } from '../../../constants/sidebar/DragAndDropTypes';
import update from 'immutability-helper'

const initialState = {
    initialData : [],
    modules : [],
    appended : [],
    deleted : [],
};

export default (state = initialState, action) => {

    switch (action.type) {
        case SidebarActionTypes.INIT_SIDEBAR:
            return {
                initialData : action.data.userModules,
                modules: action.data.userModules,
                appended : [],
                deleted : [],
            };

        case SidebarActionTypes.MOVE_IN_MODULE :

            if(action.panelName === PanelTypes.USER) {
                return update(state, {
                        modules : {
                            $splice : [[action.index, 0, action.module]]
                        }
                    }
                );
            }else{
                return state;
            }

        case SidebarActionTypes.MOVE_OUT_MODULE :
            if(action.panelName === PanelTypes.USER) {
                const module = (state.modules.find((item, idx) => item.moduleId === action.moduleId));

                if(module.type=== ModuleTypes.NORMAL ){
                    return update(state, {
                            modules: {
                                $splice : [[action.index, 0]]
                            }
                        }
                    );
                }
            }
        case SidebarActionTypes.UPDATE_MODULE :
            if(action.savingUserModule) {

                let newModule = Object.assign({}, action.module);

                // 모듈 정보 갱신
                newModule.title = action.params.label;
                newModule.parameters = action.params;
                newModule.module.data.parameters = action.params;

                return update(state, {
                        modules: {
                            $push: [newModule]
                        },
                        appended : {
                            $push: [newModule]
                        }
                    }
                );
            }
            return state;
        case SidebarActionTypes.REMOVE_MODULE :
            if(action.panelName === PanelTypes.USER) {
                let moduleIndex = state.modules.findIndex((item, idx) => item.moduleId === action.module.moduleId);
                if (moduleIndex !== -1) {
                    let deletedModule = Object.assign({}, action.module);
                    let isNewModuleIndex = state.appended.findIndex((item, idx) => item.moduleId === action.module.moduleId);
                    if(isNewModuleIndex !== -1 ) {
                        return update(state, {
                                modules: {
                                    $splice: [[moduleIndex, 1]]
                                },
                                appended: {
                                    $splice: [[isNewModuleIndex, 1]]
                                }
                            }
                        );
                    }else{
                        return update(state, {
                                modules: {
                                    $splice: [[moduleIndex, 1]]
                                },
                                deleted: {
                                    $push: [moduleIndex]
                                }
                            }
                        );
                        
                    }
                }
            }
            
            return state;
        default:
            return state;
    }
}
